import { useQuery, useMutation, useQueryClient } from 'react-query';

import { Business } from '~/types';
import { auth } from '~/api/axios';
import { editBusiness, getBusinessById } from '~/api/businesses';

export const getBusinessKey = (businessId: string) => ['business', businessId];

export const useBusiness = (businessId: string | undefined) => {
  return useQuery(
    getBusinessKey(businessId!),
    () => getBusinessById(businessId).then((res) => res.data),
    {
      enabled: !!businessId,
    }
  );
};

export const useCurrentBusiness = () => {
  const currentProfileId = auth.getProfile() as string;
  return useQuery(
    getBusinessKey(currentProfileId),
    () => getBusinessById(currentProfileId).then((res) => res.data),
    {
      enabled: !!currentProfileId,
      staleTime: Infinity,
    }
  );
};

export const useBusinessUpdate = () => {
  const currentProfileId = auth.getProfile() as string;
  const queryClient = useQueryClient();

  return useMutation(
    (businessData: Business) => editBusiness(businessData).then((res) => res.data),
    {
      onSuccess(res) {
        queryClient.setQueryData(getBusinessKey(currentProfileId), res);
      },
    }
  );
};
